// extracted by mini-css-extract-plugin
module.exports = {"container":"Privacy__container__S-6Lo"};